import { useState } from 'react'
import { useCurrent } from 'contexts'
import FlatTurfSelectField from './FlatTurfSelectField'
import ExpandedTurfSelectField from './ExpandedTurfSelectField'

export type TurfOption = {
  id: number
  name: string
  parent_id: number
  lft: number
  rgt: number
  extras: unknown
  archived: boolean
  voter_registration_enabled: boolean
} & {
  value: number
  label: string
}

const TurfSelectField = ({
  value: controlledValue = null,
  onSelect,
  turfs: customTurfOptions,
  label,
  disabled,
  showArchived,
  disableArchived,
  required,
  isExpanded,
  clearable,
  onClear,
}: {
  value?: number | null
  onSelect: (turf: number) => void
  label: string
  turfs?: TurfOption[]
  disabled?: boolean
  showArchived?: boolean
  disableArchived?: boolean
  required?: boolean
  isExpanded?: boolean
  clearable?: boolean
  onClear: () => void
}) => {
  const [searchTerm, setSearchTerm] = useState<string | undefined>(undefined)

  const { preparedTurfs, turfRefreshIsLoading } = useCurrent()

  const sortByInstanceOfSearchTerm = (
    a: { label: string },
    b: { label: string }
  ) =>
    typeof searchTerm === 'string'
      ? a.label.toLowerCase().indexOf(searchTerm.toLowerCase()) -
        b.label.toLowerCase().indexOf(searchTerm.toLowerCase())
      : 0

  return isExpanded ? (
    <ExpandedTurfSelectField
      label={label}
      value={controlledValue}
      onSelect={onSelect}
      turfs={
        customTurfOptions ||
        preparedTurfs.filter(turf => showArchived || !turf.archived)
      }
      disabled={disabled}
      disableArchived={disableArchived}
      isLoading={turfRefreshIsLoading}
      required={required}
    />
  ) : (
    <FlatTurfSelectField
      label={label}
      value={controlledValue}
      onSelect={onSelect}
      onInputChange={setSearchTerm}
      turfs={(
        customTurfOptions ||
        preparedTurfs.filter(turf => showArchived || !turf.archived)
      ).toSorted(sortByInstanceOfSearchTerm)}
      disabled={disabled}
      disableArchived={disableArchived}
      isLoading={turfRefreshIsLoading}
      required={required}
      clearable={clearable}
      onClear={onClear}
    />
  )
}

export default TurfSelectField
